<template>
  <div>
    <modal :show="true">
      <template slot="header">
        <h5 class="modal-title" id="label">{{ $t('editplayer') }}</h5>
      </template>

      <div
        class="alert alert-primary"
        role="alert"
        v-if="alertMessage"
      >{{ $t(alertMessage) }}</div>
      <div>
        <small class="text-uppercase font-weight-bold">{{ $t('nickname') }}</small>
        <base-input
        maxLength="15"   
          id="input-nickname"
          v-model="nickName"
          class="mb-3"
          v-bind:placeholder="$t('nickname')"
        />
      </div>
      <div>
        <small class="text-uppercase font-weight-bold">{{ $t('firstname') }}</small>
        <base-input
          maxLength="30"
          id="input-firstname"
          v-model="firstName"
          class="mb-3"
          v-bind:placeholder="$t('firstname')"
        />
      </div>
      <div>
        <small class="text-uppercase font-weight-bold">{{ $t('lastname') }}</small>
        <base-input
          maxLength="50"
          id="input-lastname"
          v-model="lastName"
          class="mb-3"
          v-bind:placeholder="$t('lastname')"
        />
      </div>
      <div>
        <small class="text-uppercase font-weight-bold">{{ $t('email') }}</small>
        <base-input
          maxLength="100"
          id="input-email"
          v-model="email"
          class="mb-3"
          v-bind:placeholder="$t('email')"
        />
      </div>
      <template slot="footer">
        <base-button type="danger" @click="deletePlayer()">{{$t('delete')}}</base-button>
        <base-button type="secondary" @click="closeDialog()">{{$t('close')}}</base-button>
        <base-button type="primary" @click="save()">{{$t('save')}}</base-button>
      </template>
    </modal>
  </div>
</template>

<script>

import Swal from "sweetalert2";
import {
  updatePlayerData,
  deletePlayer
} from "../services/APIService";

export default {
  props: ['editplayer'],
  data() {
    return {
      firstName: "",
      lastName: "",
      nickName: "",
      email: "",
      alertMessage: null
    };
  },
  mounted() {
    this.firstName = this.editplayer.first_name;
    this.lastName = this.editplayer.last_name;
    this.nickName = this.editplayer.nick_name;
    this.email = this.editplayer.email;

    this.$bus.$on("close", () => {
      this.$bus.$emit('close-edit-game-dialog');
    });
  },
  beforeDestroy() {
    this.$bus.$off("close");
  },  
  computed: {

  },
  methods: {
    closeDialog() {
      this.$bus.$emit("close-edit-game-dialog");
    },
    deletePlayer() {
      Swal
        .fire({
          title: this.$t("deleteplayer"),
          text: this.$t("deletedescription"),
          showCancelButton: true,
          confirmButtonText: this.$t("submit-delete-button"),
          cancelButtonText: this.$t("cancel-delete-button"),
          reverseButtons: true,
          allowOutsideClick: false,
        })
        .then(result => {
          if (result.value) {
            deletePlayer(this.editplayer.id, this.$store.state.main.game.gameCode).then(resp => {
              if (!this.$store.state.main.playerIsOnlyFacilitator && this.editplayer.id === this.$store.getters.getThisPlayer.id) {
                // Facilitator deletes self
                this.$store.commit({
                  type: "setPlayerIsOnlyFacilitator",
                  playerIsOnlyFacilitator: true,
                });

                this.$store.commit({
                  type: "setThisPlayerId",
                  playerId: null,
                });                
              }

              this.$store.dispatch("updatePlayers");

              this.$bus.$emit('close-edit-game-dialog');
            })
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            // Cancel
            this.$bus.$emit('close-edit-game-dialog');
          }
        });
    },
    save() {
      if (!this.firstName || !this.lastName || !this.nickName || !this.email) {
        this.alertMessage = "allfieldsrequired";
        return;
      }
      updatePlayerData(this.editplayer.id, this.$store.state.main.game.gameCode, this.firstName, this.lastName, this.nickName, this.email).then((resp) => {
        this.$store.dispatch("updatePlayers");
      })
      this.$bus.$emit('close-edit-game-dialog');
    }
  }
};
</script>

<i18n>
{
  "en": {
    "deleteplayer": "Delete player?",
    "deletedescription": "You should only delete a player who is not participating in the simulation. Are you sure?",
    "firstname": "* First name",
    "lastname": "* Last name",
    "nickname": "* Nick name",
    "email": "* Email",
    "editplayer": "Edit player",
    "cancel": "Cancel",
    "save": "Save",
    "delete": "Delete player",
    "close": "Close",
    "submit-delete-button": "Delete!",
    "cancel-delete-button": "Cancel",
    "allfieldsrequired": "Please fill in all fields before proceeding."
  },
  "fi": {
    "deleteplayer": "Poistetaanko pelaaja?",
    "deletedescription": "Poista vain sellainen pelaaja, joka ei osallistu simulaatioon. Oletko varma?",
    "firstname": "* Etunimi",
    "lastname": "* Sukunimi",
    "nickname": "* Kutsumanimi",
    "email": "* Sähköposti",
    "editplayer": "Muokkaa pelaajaa",
    "cancel": "Peru",
    "save": "Tallenna",
    "delete": "Poista pelaaja",
    "close": "Sulje",
    "submit-delete-button": "Poista!",
    "cancel-delete-button": "Peru",
    "allfieldsrequired": "Täytäthän kaikki kentät ennen jatkamista."
  },
  "sv": {
    "deleteplayer": "Vill du ta bort en spelare?",
    "deletedescription": "Ta endast bort en sådan spelare som inte deltar i simuleringen. Är du säker?",
    "firstname": "* Förnamn",
    "lastname": "* Efternamn",
    "nickname": "* Tilltalsnamn",
    "email": "* E-post",
    "editplayer": "Redigera spelaren",
    "cancel": "Ångra",
    "save": "Spara",
    "delete": "Ta bort spelare",
    "close": "Stäng",
    "submit-delete-button": "Ta bort!",
    "cancel-delete-button": "Ångra",
    "allfieldsrequired": "Vänligen fyll i alla fält innan du fortsätter."
  },
  "de": {
    "deleteplayer": "Spieler löschen?",
    "deletedescription": "Sie sollten nur einen Spieler löschen, der nicht an der Simulation teilnimmt. Sind Sie sicher?",
    "firstname": "* Vorname",
    "lastname": "* Nachname",
    "nickname": "* Nickname",
    "email": "* E-Mail",
    "editplayer": "Spieler bearbeiten",
    "cancel": "Abbrechen",
    "save": "Speichern",
    "delete": "Spieler löschen",
    "close": "Schließen",
    "submit-delete-button": "Löschen!",
    "cancel-delete-button": "Abbrechen",
    "allfieldsrequired": "Bitte füllen Sie alle Felder aus, bevor Sie fortfahren."
  },
  "ko": {
    "deleteplayer": "플레이어를 삭제하시겠습니까?",
    "deletedescription": "시뮬레이션에 참여하고 있지 않은 플레이어만 삭제가 가능합니다. 계속 진행하시겠습니까?",
    "firstname": "* 이름",
    "lastname": "* 성",
    "nickname": "* 닉네임",
    "email": "* 이메일",
    "editplayer": "플레이어 수정",
    "cancel": "취소",
    "save": "저장",
    "delete": "플레이어 삭제",
    "close": "닫기",
    "submit-delete-button": "삭제하기!",
    "cancel-delete-button": "취소",
    "allfieldsrequired": "모든 정보를 입력해주십시오."
  }
}
</i18n>
